import type { PokerOperationsResponse } from "./api/client.js";

export const POKER_STALE_HAND_MS = 60_000;
export const POKER_STALE_SNAPSHOT_MS = 30_000;

export function pokerAlerts(data: PokerOperationsResponse, now = Date.now()) {
  const alerts: { message: string; severity: "critical" | "high" }[] = [];
  if (now - new Date(data.sampledAt).getTime() >= POKER_STALE_SNAPSHOT_MS) {
    alerts.push({ message: "Poker operations snapshot is stale", severity: "high" });
  }
  if (!data.enabled) return alerts;
  if (!data.table)
    return [...alerts, { message: "Poker authority is unavailable", severity: "critical" }];

  if (data.table.reconciliationDifferences.length > 0) {
    alerts.push({ message: "Poker reconciliation has differences", severity: "critical" });
  }
  const lastActivity = new Date(data.table.lastEventAt ?? data.table.updatedAt).getTime();
  if (data.table.activeHandId && now - lastActivity >= POKER_STALE_HAND_MS) {
    alerts.push({ message: "Poker hand has no fresh events", severity: "high" });
  }
  const expiredLeases = data.table.seats.filter(
    (seat) => seat.connected && seat.leaseExpiresAtMs !== null && seat.leaseExpiresAtMs <= now,
  ).length;
  if (expiredLeases > 0) {
    alerts.push({
      message: `${expiredLeases} connected Poker seat${expiredLeases === 1 ? " has" : "s have"} an expired lease`,
      severity: "high",
    });
  }
  return alerts;
}
